<template>
    <div class="coupon-container">
        
    </div>
</template>

<style lang="less" scoped>

</style>